export const ADD_TO_CART = "ADD_TO_CART";
export const DELETE_ALL_FROM_CART = "DELETE_ALL_FROM_CART";
export const DELETE_PRODUCT_FROM_CART = "DELETE_PRODUCT_FROM_CART";
export const CALCULATE_TOTAL_PRICE_OF_THE_CART = "CALCULATE_TOTAL_PRICE_OF_THE_CART";
export const INCREMENT_QUANTITY = 'INCREMENT_QUANTITY';
export const DECREMENT_QUANTITY = 'DECREMENT_QUANTITY';